import { fitThumbnailsToWidth } from './thumbnailFit';

type Dimensions = Record<'height' | 'width', number>;

export type UseFluidGridOptions = {
    /**
     * The dimensions of each item in the grid
     */
    items: Dimensions[];
    /**
     * The number of pixels between each item in the grid
     */
    spacing: number;
    /**
     * The maximum row height of the grid in pixels
     */
    rowMaxHeight: number;
    /**
     * The minimum row height of the grid in pixels
     */
    rowMinHeight: number;
    /**
     * The width of each row of the grid in pixels
     */
    rowWidth: number;
    /**
     * The minimum width each item in the grid should use
     */
    itemMinWidth: number;
};

/**
 * Calculate the sizes of each items for it to fit nicely in a fluid grid layout.
 *
 * @param options - The fluid grid options
 * @returns An array of the sizes for each item in the fluid grid
 */
export const useFluidGrid = (options: UseFluidGridOptions): Dimensions[] =>
    fitThumbnailsToWidth(options.items, {

        containerSpacing: options.spacing ?? 0,
        maxContainerHeight: options.rowMaxHeight,
        minContainerHeight: options.rowMinHeight,
        minContainerWidth: options.itemMinWidth,
        rowWidth: options.rowWidth,
    });
